import type { UseQueryOptions } from "react-query";
import { useQuery } from "react-query";
import { t } from "@/i18n-js/instance";
import { marketingEmailTemplatesApi } from "@/react/api/marketingEmailTemplateApi";
import type { MarketingEmailTemplate } from "@/react/types/MarketingEmailTemplates";
import { useToast } from "@circle-react-uikit/ToastV2";

export const getTemplateDetailQueryKey = (templateId: number) => [
  "marketing_email_templates",
  "detail",
  templateId,
];

export const useTemplateDetail = (
  templateId: number,
  queryOptions?: UseQueryOptions<MarketingEmailTemplate, unknown>,
) => {
  const toast = useToast();

  return useQuery<MarketingEmailTemplate, unknown>({
    queryKey: getTemplateDetailQueryKey(templateId),
    queryFn: () => marketingEmailTemplatesApi.show({ id: templateId }),
    enabled: !!templateId,
    onError: (error: unknown) => {
      toast.error(t("request_failure_message"));
      console.error(error);
    },
    ...queryOptions,
  });
};
